import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/inquiry';

export default function Inquiry() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
